import { useEnquiry } from "./EnquiryModal";
import { waLink, DEFAULT_WA_MSG } from "../lib/site";
import { WaIcon } from "./icons";
import { Reveal } from "./Reveal";

export const CTABand = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <section className="relative overflow-hidden bg-royal py-24 text-ivory md:py-32">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-royaldeep blur-3xl" />
      <div className="relative mx-auto max-w-5xl px-6 text-center">
        <Reveal>
          <p className="eyebrow text-gold">Paramount Kitchen</p>
          <h2 className="text-balance mt-6 font-display text-4xl font-medium leading-tight md:text-6xl">
            We do not only create beautiful kitchens.
            <span className="serif-accent mt-2 block text-gold">
              We engineer the structure behind them.
            </span>
          </h2>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button
              data-testid="cta-band-design-button"
              onClick={() => openEnquiry({ source: "cta_band" })}
              className="rounded-full bg-gold px-8 py-4 text-sm font-semibold tracking-wide text-royal shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-golddim hover:text-ivory"
            >
              Design My Kitchen
            </button>
            <a
              data-testid="cta-band-whatsapp-button"
              href={waLink(DEFAULT_WA_MSG)}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/5 px-8 py-4 text-sm font-semibold tracking-wide text-ivory backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/10"
            >
              <WaIcon className="h-4 w-4" />
              WhatsApp Us
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
